import { is, isObject } from "@jaybeeuu/is";
export const assertIsSettableValueState = (candidate) => {
    if (!isObject({ set: is("function") })(candidate)) {
        throw new TypeError(`Value ${candidate.name} is not settable.`);
    }
};
//# sourceMappingURL=value-state.js.map